import { Tab, Tabs, Typography } from '@telavita-core/react-design-kit'
import React from 'react'

import { Header } from './styles'

interface IPatientHeaderProps {
  activeTab: number
  onChangeTab: (event: React.ChangeEvent, value: number) => void
}

export const PatientsHeader = ({
  activeTab,
  onChangeTab,
}: IPatientHeaderProps): JSX.Element => {
  return (
    <Header>
      <Typography italic variant='content2'>
        Visualizar pacientes que:
      </Typography>

      <Tabs
        selectedTab={activeTab}
        onChange={onChangeTab}
      >
        <Tab label="+ Faltaram" id={0} />
        <Tab label="+ Cancelaram" id={1} />
      </Tabs>
    </Header>
  )
}